import React, { useEffect, useState } from 'react';

import { getEvents } from '../../api/event';
import { getUser } from '../../api/user';
import { useUserContext } from '../../context/UserStore';
import { ConfirmDeleteHistoryItem } from '../modal/ComfirmDeleteHistoryItemModal';
import UndoRoundedIcon from '@mui/icons-material/UndoRounded';
import { Button, Card, CardContent, IconButton } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { DataGrid } from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';

// Styled component for rainbow gradient background
const RainbowCard = styled(Card)(({ theme }) => ({
  background: 'linear-gradient(-45deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4, #ffeaa7, #fab1a0, #fd79a8, #a29bfe)',
  backgroundSize: '400% 400%',
  animation: 'rainbowGradient 8s ease infinite',
  padding: '10px',
  borderRadius: '12px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  
  '@keyframes rainbowGradient': {
    '0%': {
      backgroundPosition: '0% 50%',
    },
    '50%': {
      backgroundPosition: '100% 50%',
    },
    '100%': {
      backgroundPosition: '0% 50%',
    }
  }
}));

// Animated green to purple gradient for the DataGrid
const AnimatedDataGrid = styled('div')(({ theme }) => ({
  '& .MuiDataGrid-root': {
    background: 'linear-gradient(-45deg, #10b981, #22c55e, #8b5cf6, #a855f7)',
    backgroundSize: '400% 400%',
    animation: 'greenPurpleGradient 6s ease infinite',
    borderRadius: '8px',
    color: 'white',
    
    '& .MuiDataGrid-cell': {
      color: 'white',
      fontWeight: 'bold',
    },
    
    '& .MuiDataGrid-columnHeader': {
      color: 'white !important',
      fontWeight: 'bold',
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      fontSize: '16px',
    },
    
    '& .MuiDataGrid-columnHeaderTitle': {
      color: 'white !important',
      fontWeight: 'bold',
      textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
    },
    
    '& .MuiDataGrid-footerContainer': {
      color: 'white',
    }
  },
  
  '@keyframes greenPurpleGradient': {
    '0%': {
      backgroundPosition: '0% 50%',
    },
    '50%': {
      backgroundPosition: '100% 50%',
    },
    '100%': {
      backgroundPosition: '0% 50%',
    }
  }
}));

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}
export default function OtherEventsDataGrid() {
  const { state: userState, action: userActions } = useUserContext();
  const [selectedItems, setSelectedItems] = useState([]);
  useEffect(() => {
    getUserEvents();
  }, []);
  const getUserEvents = async () => {
    const events = await userActions.getUserEventsAsync();
  };
  const handleUndo = (id) => {
    userActions.undoRuleAsync(id);
  };
  const columns = [
    // { field: 'rule', headerName: 'Rule', renderCell: (item) => item.row.change.rule?.name || 'None', width: 230 },
    // {
    //   field: 'change',
    //   headerName: 'Change',
    //   renderCell: (item) => JSON.stringify(item.row.change?.change) || 'None',
    //   width: 175,
    // },
    { field: 'type', headerName: 'Type', width: 130 },
    { field: 'created_by', headerName: 'Created By' },
    {
      field: 'created_on',
      headerName: 'Created On',
      width: 300,
      valueGetter: (value) => value.replace('T', '  Time: '),
    },
  ];

  return (
    <>
      {selectedItems}
      <RainbowCard>
        <CardContent>
          <AnimatedDataGrid>
            <DataGrid
              style={{ margin: 10 }}
              // onRowSelectionModelChange={(rowSelectionData)=>{
              //   setSelectedItems(rowSelectionData)
              // }}
              // rowSelectionModel={selectedItems}
              rows={(userState?.events || []).filter((item) => item.type !== 'do_rule')}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 },
                },
                sorting: {
                  sortModel: [{ field: 'created_on', sort: 'desc' }],
                },
              }}
              pageSizeOptions={[5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, (userState?.events || []).length]}
              checkboxSelection
            />
          </AnimatedDataGrid>
        </CardContent>
      </RainbowCard>
      {/* <ConfirmDeleteHistoryItem ids={selectedItems}/> */}
    </>
  );
}
